@import 'styles/variables';
@import 'styles/mixins.scss';
@import 'styles/blaze/mixins';

.appleButtonWrapper {
  position: relative;
  width: 100%;

  &:hover .appleButton {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--light-4);
      border-radius: 10px;
      pointer-events: none;
    }
  }
}

.appleButton {
  position: relative;
}

.googleButton {
  @include md-sohne;
  width: 100%;
  height: 48px;
  padding: none;

  @include for-tablet-portrait-max {
    width: 100%;
  }

  svg {
    height: 18px;
    width: 18px;
  }
}

.facebookLogo {
  position: absolute;
  left: 10px;
  top: 8px;
  background-color: white;
  border-radius: 999px;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include for-desktop-only {
    top: 12px;
    left: 12px;

    svg {
      height: 24px !important;
      width: 24px !important;
    }
  }
}

.googleLogo {
  position: absolute;
  left: 10px;
  top: 8px;
  background-color: white;
  border-radius: 999px;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include for-desktop-only {
    position: relative;
    top: 0;
    left: 0;
    margin-right: 0;
  }
}

.buttonText {
  @include for-desktop-only {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
  }
}

.appleLogo {
  position: absolute;
  left: 10px;
  top: 8px;
  background-color: white;
  border-radius: 999px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  @include for-desktop-only {
    position: relative;
    top: 0;
    left: 0;
    margin-right: 0;
  }
}
